<template>
  <div>
    <div class="content-box monthChart">
      <div class="content-box-title title2">
        <van-image
          :src="require('../assets/img/title-icon2.png')"
          width="16px"
          height="16px"
          class="icon"
        ></van-image>

        月度学分
        <div class="select-btn" @click="picker = true"><van-icon name="filter-o" />筛选</div>
      </div>
      <div class="content-box-container" style="position: relative;">
        <div ref="monthBar" style="height: 180px;"></div>
        <div style="position: absolute;bottom:5px;right:5px;" class="rmk-txt">
          不含充电保
        </div>
      </div>
    </div>
    <van-popup v-model="picker" round closeable position="bottom">
      <div class="pop-box">
        <div v-show="!isUser">
          <div class="pop-box-title">岗位名称</div>

          <van-row class="pop-box-item" style="align-items: end;" gutter="5">
            <van-col span="8">
              <div class="active" @click="jobPicker = true">{{ currentJobNm }}</div></van-col
            >
            <van-col span="8">
              <span
                style="font-size: 12px;color: #666;margin-left: 10px;text-decoration: underline;"
                @click="jobPicker = true"
                >点击选择</span
              >
            </van-col>
          </van-row>
        </div>

        <div class="pop-box-title">课程分类</div>
        <van-row class="pop-box-item" type="flex" gutter="5">
          <van-col span="8" v-for="types in typeList" :key="types.id">
            <div @click="selectType = types.id" :class="{ active: types.id == selectType }">
              {{ types.title }}
            </div></van-col
          >
          <van-col span="8" v-for="(e, j) in typeList.length % 3" :key="e + j + '99'" />
        </van-row>

        <div class="pop-box-title">课程形式</div>
        <van-row class="pop-box-item" type="flex" gutter="5">
          <van-col span="8" v-for="course in courseParams" :key="course.id"
            ><div
              @click="selectCourse = course.dictValue"
              :class="{ active: course.dictValue == selectCourse }"
            >
              {{ course.dictLabel }}
            </div></van-col
          >
          <van-col span="8" v-for="(e, j) in typeList.length % 3" :key="e + j + ''" />
        </van-row>
        <div class="btns">
          <div @click="reset" class="reset-btn">重置</div>
          <div @click="submitPop" class="submit-btn">确定</div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="jobPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="jobList"
        value-key="name"
        @cancel="jobPicker = false"
        @confirm="handleChangeJob"
      />
    </van-popup>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { getMonthStudy, getPostList, getMapList, getMonthStudyXY } from '@/api/common/index.js'
import { getDictType } from '@/api/index.js'
export default {
  name: 'monthChart',
  props: {
    dealerId: {
      type: String,
    },
    ppn: {
      type: String,
    },
    companyId: {
      type: Number,
    },
    isUser: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      userType: localStorage.getItem('userType'),
      monthChart: null,
      jobList: [],
      jobPicker: false,
      selectJob: null,
      currentJobNm: '全部',
      picker: false,
      typeList: [],
      selectType: null,
      //typePicker: false,
      courseParams: [],
      selectCourse: null,
      //paramsPicker: false,
      courseIntegral: [],
      userAvg: [],
      scale: [],
      postId: '',
      xData: [],
    }
  },
  watch: {
    dealerId() {
      this.getMonthData()
    },
    ppn() {
      this.getMonthData()
    },
    companyId() {
      this.getMonthData()
    },
  },
  methods: {
    getMap() {
      getMapList({}).then((res) => {
        this.typeList = [
          {
            title: '全部',
            id: null,
          },
        ].concat(res.data)
      })
    },
    getCourseType() {
      getDictType('bsd_course_source').then((res) => {
        this.courseParams = [
          {
            dictLabel: '全部',
            dictValue: null,
          },
        ].concat(res.data)
      })
    },
    getPost() {
      getPostList({}).then((res) => {
        this.jobList = [
          {
            name: '全部',
            id: null,
          },
        ].concat(res.data)
      })
    },
    getMonthData() {
      if (!this.isUser) {
        getMonthStudy({
          companyId: this.companyId,
          dealerId: this.dealerId,
          ppn: this.ppn,
          postId: this.selectJob,
          mapId: this.selectType,
          courseSource: this.selectCourse,
        }).then((res) => {
          this.courseIntegral = res.data.courseIntegral
          this.userAvg = res.data.userAvg
          this.scale = res.data.scale
          this.xData = res.data.month
          this.initMonth()
        })
      } else {
        getMonthStudyXY({
          ppn: this.ppn,
          postId: this.selectJob,
          mapId: this.selectType,
          courseSource: this.selectCourse,
        }).then((res) => {
          this.courseIntegral = res.data.courseIntegral
          this.userAvg = res.data.userIntegral
          this.scale = res.data.userAvg
          this.xData = res.data.month
          this.initMonth()
        })
      }
    },
    handleChangeJob(value) {
      this.currentJobNm = value.name
      this.selectJob = value.id
      this.jobPicker = false
    },
    reset() {
      this.selectJob = null
      this.selectType = null
      this.selectCourse = null
      this.currentJobNm = '全部'
    },
    submitPop() {
      this.picker = false
      this.getMonthData()
    },
    initMonth() {
      let that = this
      this.monthChart = echarts.init(this.$refs.monthBar)
      this.monthChart.setOption({
        // backgroundColor: 'transparent',
        grid: {
          top: 35,
          left: 10,
          right: 10,
          bottom: 10,
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: !that.isUser
            ? ['学分总数', '人均学分', '参训率']
            : ['学分总数', '我的学分', '人均学分'],
          itemWidth: 20,
          itemHeight: 6,
          right: 5,
          top: 5,
        },
        toolbox: {
          show: false,
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            // prettier-ignore
            data: that.xData,
            axisTick: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#eee',
                type: 'dashed',
              },
            },
            axisLabel: {
              interval: 0,
              color: 'rgba(0, 0, 0, 0.5)',
              fontSize: 10,
              fontWeight: 400,
              fontFamily: 'Porsche Next',
              rotate: 30,
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              color: 'rgba(0, 0, 0, 0.5)',
              fontSize: 10,
              fontWeight: 400,
              fontFamily: 'Porsche Next',
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#eee',
                type: 'dashed',
              },
            },
            splitLine: {
              lineStyle: {
                color: '#eee',
                type: 'dashed',
              },
            },
          },
          !that.isUser
            ? {
                type: 'value',
                min: 0,
                max: 100,
                interval: 20,
                axisLabel: {
                  formatter: '{value} %',
                  color: 'rgba(0, 0, 0, 0.5)',
                  fontSize: 10,
                  fontWeight: 400,
                  fontFamily: 'Porsche Next',
                },
              }
            : null,
        ],
        series: [
          {
            name: '学分总数',
            type: 'bar',
            barWidth: 15,
            barGap: '-100%',
            data: that.courseIntegral,
            itemStyle: {
              color: '#403F45',
            },
          },
          !that.isUser
            ? {
                name: '人均学分',
                type: 'bar',
                barWidth: 8,
                barGap: '-75%',
                z: 10,
                data: that.userAvg,
                itemStyle: {
                  color: '#D5001C',
                },
              }
            : {
                name: '我的学分',
                type: 'bar',
                barWidth: 8,
                barGap: '-75%',
                z: 10,
                data: that.userAvg,
                itemStyle: {
                  color: '#D5001C',
                },
              },
          !that.isUser
            ? {
                name: '参训率',
                type: 'line',
                smooth: true,
                yAxisIndex: 1,
                tooltip: {
                  valueFormatter: function(value) {
                    return value + ' %'
                  },
                },
                data: that.scale,
                itemStyle: {
                  color: '#666',
                },
              }
            : {
                name: '人均学分',
                type: 'line',
                smooth: true,
                // tooltip: {
                //   valueFormatter: function(value) {
                //     return value + ' %'
                //   },
                // },
                data: that.scale,
                itemStyle: {
                  color: '#666',
                },
              },
        ],
      })
      this.monthChart.on('click', function(event) {
        if (!that.isUser) {
          let month = event.dataIndex + 1
          that.$router.push({
            path: '/course/detail',
            query: {
              id: month,
            },
          })
        } else {
          return
        }
      })
    },
  },
  created() {},
  mounted() {
    if (this.dealerId == null) {
      this.getMonthData()
    }
    this.getPost()
    this.getMap()
    this.getCourseType()
    //this.initMonth()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.content-box {
  &-title {
    .select-btn {
      margin-left: 12px;
      background: url('../assets/img/rectangle-select.png') center no-repeat;
      background-size: contain;
      width: 60px;
      height: 22px;
      line-height: 22px;
      text-align: center;
      color: #fff;
      font-size: 13px;
    }
  }
  &.monthChart {
    background-size: contain;
  }
}
.pop-box {
  padding: 20px;
  max-height: 70vh;
  overflow-y: auto;
  &-title {
    color: #000;
    font-size: 16px;
    margin-bottom: 10px;
  }
  &-item {
    // display: flex;
    // justify-content: space-between;
    margin-bottom: 10px;
    .van-col > div {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-size: 13px;
      font-weight: 400;
      min-height: 28px;
      height: auto;
      line-height: 16px;
      padding: 6px 4px;
      margin-bottom: 5px;
      border: 0.5px solid rgba(218, 217, 222, 1);
      border-radius: 8px;
      color: rgba(64, 63, 69, 1);
      background-color: #fff;
      word-break: break-all;
      white-space: normal;
      box-sizing: border-box;
      &.active {
        background-color: rgba(213, 0, 28, 0.2);
        color: rgba(213, 0, 28, 1);
      }
    }
  }
  .btns {
    display: flex;
    font-size: 15px;
    font-weight: 500;
    margin-top: 30px;
    .reset-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 177px;
      height: 40px;
      margin-right: 5px;
      background: url('../assets/img/reset-btn.png') center no-repeat;
      background-size: contain;
      color: rgba(115, 114, 120, 1);
    }
    .submit-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 177px;
      height: 40px;
      background: url('../assets/img/submit-btn.png') center no-repeat;
      background-size: contain;
      color: #fff;
    }
  }
}
</style>
